import { createAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';

export interface ChangeTranscriptStatus {
    status: 'grey' | 'green';
}

export const changeTranscriptStatus = createAction<
    ActionType,
    ChangeTranscriptStatus
>(ActionType.COACHING__CA__CHANGE_TRANSCRIPT_STATUS);
